define(function (require) {
    "use strict";

	var LE = require("app");
    var Page = require("ui.components/page/Page");
    var Dialog = require("ui/dialog/Dialog");
    var Constant = require("content-config/constant.json");
    var RevisionUtility = require("utils/RevisionUtility");

    var ContentSystemEditLayout = require("content-views/content-edit/system/ContentSystemEditLayout");
    var EditSystemTextView = require("content-views/content-edit/system/EditSystemTextView");

    var ContentSystemEditPageModel = require("content-models/system/ContentSystemEditPageModel");
    var ContentSystemModel = require("content-models/system/ContentSystemModel");
    var ContentSystemModelAll = require("content-models/system/ContentSystemModelAll");
    var ContentSystemDefaultsModel = require("content-models/system/ContentSystemDefaultsModel");

    var ContentSystemMessagingEditPageModel = require("content-models/system-messaging/ContentSystemMessagingEditPageModel");
    var ContentSystemMessagingModel = require("content-models/system-messaging/ContentSystemMessagingModel");
    var ContentSystemMessagingModelAll = require("content-models/system-messaging/ContentSystemMessagingModelAll");

    var ContentSystemAssignSkillDialogView = require("content-views/content-gallery/system/ContentSystemAssignSkillDialogView");

    var StringFormats = require("utils/StringFormats");
    var ErrorCodes = require("codeTables/errorCodes.json");

    var ContentSystemEditController = {};
    var TYPES = Constant.CONTENT_TYPES;
    var ROUTE_BASE = Constant.ROUTE_BASE;

    var TYPE_CONFIGURATION = {};
    TYPE_CONFIGURATION[TYPES.SYSTEM] = {
        ModelALL: ContentSystemModelAll,
        PageModel: ContentSystemEditPageModel,
        AdditionalPageClassName: "system-messages-edit-chat-page"
    };

    TYPE_CONFIGURATION[TYPES.SYSTEM_MESSAGING] = {
        ModelALL:  ContentSystemMessagingModelAll,
        PageModel: ContentSystemMessagingEditPageModel,
        AdditionalPageClassName: "system-messages-edit-messaging-page"
    };

    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentSystemEditController = Marionette.Controller.extend({

            dialog: null,
            contentId: null,
            newAssignSkills: [],
            selectedContentModel: null,
            isDataChanged: false,

            initialize: function(options) {
                this._initialize(options);
            },

            getMainView: function () {
                return this.mainView;
            },

            editSystemMessage: function (options) {
                LEContent.logger.debug("edit system message", "ContentSystemEditController:editSystemMessage");
                if (options.contentId == this.pageModel.getContentModel().getID() ) {   //doing == to use "12123" == 12123 = true
                    //show already loaded or in the middle of edit content
                    this._editAlreadyEditedSystemMessage(options);
                } else {
                    this._editSystemMessage(options);
                }
            },

            onClose: function () {
                LEContent.logger.info("closing", "ContentSystemEditController:close");
                this.contentSystemEditLayout.close();
                this.mainView.close();
                this.channel.reset();
            },

            //private functions
            //*********************************************************
            _initialize: function (options) {
                LEContent.logger.info("initializing", "ContentSystemEditController:initialize");
                this.type = options.type;
                this.channel = LEContent.media.channel("ContentSystemEditController" + this.type);
                this.reqres = this.channel.reqres;

                this.pageModel = new TYPE_CONFIGURATION[this.type].PageModel();

                this._createViews();
                this._bindEvents();
                this._bindRequests();
            },

            _bindEvents: function () {
                //layout view
                this.listenTo(this.channel, "contentSystemEditLayout:actions:restoreToDefaults", this._restoreToDefaults);
                this.listenTo(this.channel, "contentSystemEditLayout:cancel", this._cancelEdit);
                this.listenTo(this.channel, "contentSystemEditLayout:closeWindow", this._cancelEdit);
                this.listenTo(this.channel, "contentSystemEditLayout:changePage", this._changePage);
                this.listenTo(this.channel, "editorSystemWrapperView:save", this._save);
                this.listenTo(this.channel, "editorSystemWrapperView:delete", this._delete);

                //editor view events
                this.listenTo(this.channel, "editorSystemWrapperView:editor:text:change", this._contentMessageChanged);

                //system text edit events
                this.listenTo(this.channel, "editorSystemWrapperView:toggle:activate:change", this._enabledStateChanged);
                this.listenTo(this.channel, "editSystemTextView:timer:change", this._timerChanged);

                this.listenTo(this.pageModel,"change:header.*",this._showHeaderAccordingToModel);

                //Selected/Default site languages Changed
                this.listenTo(LE.vent, "siteSettings:supportedDefaultLanguageCodesChanged", this._siteLanguagesChange, this);

                this.listenTo(this.channel, "skillTabsView:click:tab",this._clickSkillTab, this);
                this.listenTo(this.channel, "skillTabView:add:skills",this._assignSkillsToSystemContent);
            },

            _bindRequests: function(){
                this.reqres.setHandler("tabsbar:language:validateContentPreLanguageChange", this._validateContentPreLanguageChange, this);
            },

            _getCollectionName: function(){
                if (TYPES.SYSTEM_MESSAGING === this.type) {
                    return LEContent.getDataManager().getEntities().SYSTEM_MESSAGING;
                }else{
                    return LEContent.getDataManager().getEntities().SYSTEM;
                }
            },
            _editAlreadyEditedSystemMessage: function(){
                this.pageModel.initSkillTabs(this.modelAll, this.pageModel.getSelectedSkill(), this.pageModel.getSelectedLanguage(),this.newAssignSkills);
            },
            _editSystemMessage: function (options) {
                LEContent.logger.debug("fetching system message for edit", "ContentSystemEditController:_editSystemMessage. options = " + options);
                this._closeAssignSkillsDialog(); // make sure the dialog is closed
                this._showLoader();
                options = options || {};
                if(options.contentId) {
                    if(this.contentId && this.pageModel&& options.contentId !== this.contentId) {
                        this.pageModel.setSelectedSkill(ContentSystemEditPageModel.DEFAULT_SKILL_NAME);
                    }
                    this.contentId = options.contentId;
                    this.newAssignSkills = [];
                }
                this.modelAll =  new TYPE_CONFIGURATION[this.type].ModelALL({ "id": this.contentId});
                //the content model that contain all contexts both the account context and skill contexts saved for this system messsage.
                this.modelAll.fetch({
                    success: _.bind(this._onFetchSystemMessageSuccess, this,options.skillIdSelectedAfterSave, options.selectedLanguageAfterSave),
                    error:  _.bind(this._onFetchSystemMessageError, this)
                });

            },

            _createViews: function(){
                LEContent.logger.debug("create view", "ContentSystemEditController:_createViews.");
                this.contentSystemEditLayout = new ContentSystemEditLayout({
                    model: this.pageModel,
                    reqres: this.reqres,
                    channel: this.channel
                });

                this.mainView = new Page({
                    moduleName:LEContent.moduleName,
                    context:LE.context,
                    isPermanent: true,
                    view:        this.contentSystemEditLayout,
                    additionalClassName:  TYPE_CONFIGURATION[this.type].AdditionalPageClassName,
                    header: {
                        title:       "",
                        description: ""
                    }
                });
            },

            _siteLanguagesChange: function(languagesChanges){
                //before updating the tabs find out what was added, what was removed
                var removedLanguages = this.pageModel.getRemovedLanguageCodes();
                var addedLanguageCodes = this.pageModel.getAddedLanguageCodes();

                this.pageModel.initLanguageTabs(); //Update the tabs - for the view

                //Then update the data:
                if (this.pageModel.isContentEmpty()){
                    //do not update model languages data if its a new model or the empty model
                } else {
                    this.pageModel.deleteRemovedLanguagesData(removedLanguages);
                    this._fetchMissingLanguages(addedLanguageCodes);
                }
            },

            /**
             * add data of added languages if exists in the server DB
             * @param missingLanguageCodes
             * @private
             */
            _fetchMissingLanguages: function(missingLanguageCodes){
                LEContent.logger.debug("Fetching Missing Languages", "ContentSystemTableController:_fetchMissingLanguages. missingLanguageCodes = " + missingLanguageCodes);
                if (missingLanguageCodes.length !== 0) {
                    this._showLoader();
                    this.modelAll = new TYPE_CONFIGURATION[this.type].ModelALL({ "id": this.pageModel.getModelID()});
                    this.modelAll.fetch({  //todo handle 404 - baasa
                        success: _.bind(function (model, response, options) {
                            this.pageModel.appendAddedLanguagesData(model, missingLanguageCodes);
                            this._closeLoader();
                        }, this),
                        error: _.bind(function (model, response, options) {
                            LEContent.logger.debug("fetch content error", "ContentSystemEditController:_fetchMissingLanguages");
                            this._closeLoader();
                            if (TYPES.SYSTEM_MESSAGING == this.type && response.status == 404){
                                //not error 404 is allowed for messaging system messages
                            } else {
                                LEContent.notifier.showError(LE.translator.translate("LEContent.content.edit.get.data.error"));
                            }


                        }, this)
                    });
                }
            },
            _onFetchSystemMessageSuccess: function(skillIdSelectedAfterSave, selectedLanguageAfterSave) {
                LEContent.logger.debug("fetch system content success closing loader ", "ContentSystemEditController:editSystemMessage");
                if(skillIdSelectedAfterSave) {
                    this._prepareModel(skillIdSelectedAfterSave, selectedLanguageAfterSave);
                } else {
                    this._prepareModel(this.pageModel.getSelectedSkill(), selectedLanguageAfterSave);
                }
                this._showSystemTextEdit();
                this._closeLoader();
            },

            _addAssignSkills: function(newAssignSkills) {
                LEContent.logger.debug("add assigned skill to origin data", "ContentSystemEditController:_addAssignSkills. newAssignSkills = " + newAssignSkills);
                this.newAssignSkills = _.union(this.newAssignSkills, newAssignSkills);
                this._prepareModel(this.pageModel.getSelectedSkill());
                this._restoreSelectedData();
                this._closeAssignSkillsDialog();
            },

            _onFetchSystemMessageError: function(model, response, options) {
                if (TYPES.SYSTEM_MESSAGING == this.type && response.status == 404) { //404 is ok - it means no override
                    model.setRevision(RevisionUtility.parseRevisionFromXhr(options.xhr));
                    return this._onFetchSystemMessageSuccess();
                }
                LEContent.logger.debug("fetch system content error closing loader returning to list", "ContentSystemEditController:_onFetchSystemMessageError");
                this._closeLoader();
                LEContent.notifier.showError(LE.translator.translate("LEContent.content.edit.get.data.error"));
                this._routeToTable();
            },

            _prepareModel: function(selectedSkillId, selectedLanguageId){
                LEContent.logger.debug("prepare model", "ContentSystemEditController:_prepareModel. selectedSkillId = " + selectedSkillId + ". selectedLanguageId = " + selectedLanguageId);
                var model = this.modelAll.getContextModelBySkill(selectedSkillId);
                this.pageModel.setContentModel(model);
                this.pageModel.initSkillTabs(this.modelAll, selectedSkillId, selectedLanguageId, this.newAssignSkills);

                this.listenTo(model,"invalid",this._onInvalidModel);
            },

            _showHeaderAccordingToModel: function () {
                LEContent.logger.debug("show headers of page", "ContentSystemEditController:_showHeaderAccordingToModel");
                var header = this.pageModel.getHeader();
                var title =        _.isString(header.title) && header.title.length > 0? LE.translator.translate(header.title): "";
                var description =  _.isString(header.description) && header.description.length > 0? LE.translator.translate(header.description): "";

                this.mainView.setTitle(title);
                this.mainView.setDescription(description);
            },

            _showSystemTextEdit: function () {
                LEContent.logger.debug("show systemHtml", "ContentSystemEditController:_showSystemTextEdit");
                if (!this.contentSystemEditLayout.leftPane.currentView) {
                    this.editSystemTextView = new EditSystemTextView({channel: this.channel,reqres: this.reqres, model: this.pageModel});
                    this.contentSystemEditLayout.leftPane.show(this.editSystemTextView);
                }

                this._updateButtonsState(this.pageModel.getSelectedSkill());
            },

            _validateContentPreLanguageChange: function() {
                 return this.pageModel.validateContent();
            },

            _contentMessageChanged: function (message) {
                this.pageModel.setContentMessage(message);
            },

            _restoreToDefaults: function() {
                LEContent.logger.debug("restore data to default", "ContentSystemEditController:_restoreToDefaults");
                if (this.type == TYPES.SYSTEM_MESSAGING) {
                    this._restoreSystemMessagingDefaults();
                    this.restoreSystemMessagingDefaultsFlag = true;
                }else {
                    this._restoreSystemDefaults();
                }
            },
            _restoreSystemMessagingDefaults: function() {
                var defaultModel = LEContent.getDataManager().getDefaultMessagingAutoMessagesModel(this.pageModel.getModelID());
                this.pageModel.resetContentModel(defaultModel.clone());
                this._contentMessageChanged(this.pageModel.getContentMessage());
            },
            _restoreSystemDefaults: function() {
                var tempModel;
                this._showLoader();

                tempModel = new ContentSystemDefaultsModel({ "id": this.pageModel.getTemplateId()});

                tempModel.fetch({
                    success: _.bind(function (model, response, options) {
                        this.pageModel.setDefaultLanguageData(model.get("data"));
                        this._contentMessageChanged(this.pageModel.getContentMessage());
                        this._closeLoader();
                    }, this),
                    error: _.bind(function (model, response, options) {
                        LEContent.logger.debug("fetch content error", "ContentSystemEditController:_restoreToDefaults");
                        LEContent.notifier.showError(LE.translator.translate("LEContent.content.edit.get.data.error"));
                        this._closeLoader();
                    }, this)
                });
            },

            _enabledStateChanged: function (state) {
                this.pageModel.setEnabledState(state);
            },

            _timerChanged : function(time){
                this.pageModel.setSystemMessageTimer(time);
            },

            _changePage: function(idx){
                LEContent.logger.debug("change auto message", "ContentSystemEditController:_changePage. idx = " + idx);
                if (idx !== this.pageModel.getContentPageInfoCurrentPage()) {
                    this.pageModel.setContentPageInfoCurrentPage(idx);
                    var viewInvalid = this._validateView() > 0;
                    if (this.pageModel.hasChanges() || viewInvalid || !_.isEmpty(this.newAssignSkills)){
                        //prompt user if to continue and lose changes or cancel and stay on the page?
                        this.pageModel.setAllowMiniErrors(false); // hide mini errors when prompt is on, and page is about to be changed
                        this._showNotification( this._changePageSaveCallback, this._changePageActionCallback, this._changePageCancelCallback,
                            {idx: idx, content: LE.translator.translate("LEContent.content.edit.route.confirmation.msg")});
                    } else {
                        this._routeToItem(idx);
                    }
                }
            },

            _routeToItem: function (idx){
                LEContent.logger.debug("route to auto message", "ContentSystemEditController:_routeToItem. idx = " + idx);
                this._clear();
                this.pageModel.setSelectedSkill(ContentSystemEditPageModel.DEFAULT_SKILL_NAME);

                var itemId = LEContent.getDataManager().getItemIDByIndex(this.pageModel.getContentModel(),idx,this._getCollectionName());
                var route = this._getBaseRoute();
                if ((_.isNumber(itemId) && itemId > -1) || (_.isString(itemId) && itemId.length > 0)) {  //chat auto messages ID is number messaging is text.
                    route = route + "/"+ itemId;
                }

                LEContent.logger.debug("Routing to: " + route, "ContentSystemEditController:_previousItem");
                LEContent.router.navigateNonBackable(route);
            },

            _getBaseRoute: function(){
                return ROUTE_BASE[this.type];
            },

            _save: function (options) {
                LEContent.logger.debug("save model", "ContentSystemEditController:_save. options = " + options);
                options = options || {};
                var modelToSave = this.pageModel.getContentModel();

                if (this._validateView(modelToSave) === 0) {
                    var isSkillContext = false;
                    var selectedSkill = this.pageModel.getSelectedSkill();
                    if(ContentSystemEditPageModel.DEFAULT_SKILL_NAME !== selectedSkill) {
                        modelToSave.setSkillId(selectedSkill);
                        isSkillContext = true;
                    }
                    modelToSave.setSelectedLanguage(this.pageModel.getSelectedLanguage());
                    this._showLoader();
                    modelToSave.save(null, {
                        success: _.bind(function () {
                            LEContent.logger.info("content successfully saved", "ContentSystemEditController:_save");
                            this._onSaveSuccess(options, selectedSkill, modelToSave);
                        }, this),
                        error: _.bind(function (model, response, options) {
                            LEContent.logger.error("Failed to save content", "ContentSystemEditController:_save", response);
                            this._onSaveError(model, response, options, selectedSkill, modelToSave);
                        }, this)
                    }, isSkillContext);
                }
                else {   //we have view validation errors lets activate model validation to show all together now
                    LEContent.logger.debug("validateView Failed", "ContentSystemEditController:onSave");
                    modelToSave.isValidAttr();
                }
            },

            _onSaveSuccess: function(options, selectedSkill, modelToSave){
                this._closeLoader();
                this._clear();
                this.deleteNewAssignSkill(selectedSkill);
                if(options.successCallback && options.autoMessageId) {
                    options.successCallback.call(this, options.autoMessageId);
                } else {
                    this._editSystemMessage({skillIdSelectedAfterSave: options.skillIdSelectedAfterSave, selectedLanguageAfterSave: modelToSave.getSelectedLanguage()});
                }
            },

            _onSaveError: function(model, response, options, selectedSkill, modelToSave){
                this._closeLoader();
                var errorMessage = LE.translator.translate("LEContent.content.edit.save.auto.message.error");
                if(response && (response.status === 403 || response.status === 401)){
                    errorMessage = LE.translator.translate("LEFramework.errors.serverError.1201");
                }
                if(response && response.status === 404){
                    errorMessage = LE.translator.translate("LEFramework.errors.serverError.1201");
                }
                if (response && response.responseError && response.responseError.internalCode === ErrorCodes.noDataFound){
                    //scenario: restore a message (messaging) by using the default or load a default message. add a character and remove it. save is enabled
                    //save will actually issue a delete request for the override
                    errorMessage = '';
                    this._clear();
                    this.deleteNewAssignSkill(selectedSkill);
                    this._editSystemMessage({selectedLanguageAfterSave: modelToSave.getSelectedLanguage()});
                }
                if (!_.isEmpty(errorMessage)){
                    LEContent.notifier.showError(errorMessage);
                    this.pageModel.revertContentPageNumberChange();
                }
            },

            _delete: function () {
                LEContent.logger.debug("show notification to delete auto message or remove not existinf auto message", "ContentSystemEditController:_delete");
                var modelToDelete = this.pageModel.getContentModel();
                var selectedSkill = this.pageModel.getSelectedSkill();

                if(this.newAssignSkills.indexOf(parseInt(selectedSkill, 10)) === -1) {
                    this._showNotification( this._deleteCallback, null, this._cancelCallback,
                                            {title: LE.translator.translate("LEContent.content.edit.delete.confirmation.title"),
                                            content: LE.translator.translate("LEContent.content.edit.delete.confirmation.msg"),
                                            removePrimaryButton: false, removeMiddleButton: true,
                                            text: LE.translator.translate("LEFramework.global.captions.yes"), modelToDelete: modelToDelete, selectedSkill: selectedSkill});
                } else {
                    this.modelAll.deleteContextSkill(selectedSkill);
                    this.deleteNewAssignSkill(selectedSkill);
                    this._prepareModel(ContentSystemEditPageModel.DEFAULT_SKILL_NAME);
                    this._updateButtonsState(this.pageModel.getSelectedSkill());
                }
            },

            _deleteSkill: function (modelToDelete, selectedSkill) {
                LEContent.logger.debug("delete auto message", "ContentSystemEditController:_deleteSkill. modelToDelete = " + modelToDelete + ". selectedSkill = " + selectedSkill);
                if (this._validateView(modelToDelete) === 0) {
                    this._showLoader();

                    modelToDelete.setSkillId(selectedSkill);
                    modelToDelete.destroy({
                        success: _.bind(function (model, resp, options) {
                            this.deleteNewAssignSkill(selectedSkill);
                            this.pageModel.setSelectedSkill(ContentSystemEditPageModel.DEFAULT_SKILL_NAME);
                            this._editSystemMessage({selectedLanguageAfterSave: this.pageModel.getSelectedLanguage()});
                            this._clear();
                        }, this),
                        error: _.bind(function (model, response, options) {
                            this._closeLoader();
                            LEContent.logger.error("Failed to delete content", "ContentSystemEditController:_delete", response);
                            var errorMessage = LE.translator.translate("LEContent.content.edit.delete.auto.message.error");
                            if (response && response.responseError && response.responseError.internalCode && response.responseError.internalCode === ErrorCodes.dependencyConflict) {
                                errorMessage = LE.translator.translate("LEContent.content.edit.409.error");
                            }
                            LEContent.notifier.showError(errorMessage);
                        }, this)
                    });
                }
                else {   //we have view validation errors lets activate model validation to show all together now
                    LEContent.logger.debug("validateView Failed", "ContentSystemEditController:_deleteSkill");
                    modelToDelete.isValidAttr();
                }
            },

            deleteNewAssignSkill: function(skillId) {
                var indexSkill = this.newAssignSkills.indexOf(skillId);
                if (indexSkill > -1) {
                    this.newAssignSkills.splice(indexSkill, 1);
                }
            },

            //check for view errors in the inner components
            _validateView : function(model) {
                var errCount = this.contentSystemEditLayout.validateView();
                if (model) {
                    model.viewErrors = errCount;
                }
                return errCount;
            },

            _routeToTable: function () {
                LEContent.router.navigateBack();
            },

            _clear: function () {
                this.stopListening(this.pageModel.getContentModel());
                this.pageModel.clear();
            },

            //error handling
            _onInvalidModel:function (model, errors) {
                this._closeLoader();
                this.pageModel.revertContentPageNumberChange();

                LEContent.logger.debug("Content message is invalid.", "ContentSystemEditController::_invalidModel");
                var numOfErrors = _.keys(errors).length;
                if (model.viewErrors > 0){
                    numOfErrors+=model.viewErrors-1;
                }
                LEContent.notifier.showError(StringFormats.getGeneralErrorMsgByNumOfErrors(numOfErrors));

                var i = 0;
                _.each(errors,function(val,key){
                    i++;
                    LEContent.logger.debug("validation error msg "+i+": "+key+" - "+val,"ContentSystemEditController::_invalidModel");
                });
            },

            _assignSkillsToSystemContent: function (){
                LEContent.logger.debug("open skills dialog if content exist", "ContentSystemEditController:_assignSkillsToSystemContent");
                var selectedSystemContent = this.pageModel.getContentModel().getID();
                if (selectedSystemContent) {
                    this._showLoader();
                    this._openAssignSkillsDialog();
                }
            },

            _assignSkillChanged: function (skillId){
                LEContent.logger.debug("skill changed", "ContentSystemEditController:_assignSkillsToSystemContent. skillId = " + skillId);
                this._updateButtonsState(skillId);
                this._prepareModel(skillId);
            },

            _clickSkillTab: function (skillId, view){
                LEContent.logger.debug("click to skill", "ContentSystemEditController:_clickSkillTab. skillId = " + skillId);
                if(this.pageModel.getIsSaveAllowed()) {
                    this._showNotification(this._unsavedChangesSaveCallback, this._unsavedChangesActionCallback, this._cancelCallback, {skillId: skillId});
                } else {
                    this._assignSkillChanged(skillId);
                }
            },

            _updateButtonsState: function (skillId){
                LEContent.logger.debug("update delete and restore to default buttons state", "ContentSystemEditController:_updateButtonsState. skillId = " + skillId);
                if(skillId && ContentSystemEditPageModel.DEFAULT_SKILL_NAME !== skillId) {
                    this.editSystemTextView.updateButtonsState(true);
                } else {
                    this.editSystemTextView.updateButtonsState(false);
                }
            },

            _openAssignSkillsDialog: function() {
                LEContent.logger.debug("Initiating and openning the assignSkill dialog ", "ContentSystemTableController:_openAssignSkillsDialog");
                this._closeLoader();

                this.selectedContentModel = this.pageModel.getContentModel();
                this.isDataChanged = this.pageModel.hasChanges();
                var assignSkills = this.modelAll.getContextSkill();

                this.contentSystemAssignSkillDialogView = new ContentSystemAssignSkillDialogView({assignSkills: assignSkills, newAssignSkills: this.newAssignSkills});
                this.mainView.setIgnoreDomEvents(true);
                this.dialog = new Dialog({
                    innerView: this.contentSystemAssignSkillDialogView,
                    moduleName:LEContent.moduleName,
                    context:LE.context
                });
                this.contentSystemEditLayout.dialogContainerRegion.show(this.dialog);
                this.listenTo(this.contentSystemAssignSkillDialogView, "dialogInnerView:closeDialog", this._closeAssignSkillsDialog);
                this.listenTo(this.contentSystemAssignSkillDialogView, "dialogInnerView:onSaveClick", this._addAssignSkills);
            },

            _closeAssignSkillsDialog: function() {
                LEContent.logger.debug("Closing the assignSkill dialog", "contentSystemTableController:_closeAssignSkillsDialog");
                if (this.contentSystemAssignSkillDialogView && this.dialog) {
                    this.stopListening(this.contentSystemAssignSkillDialogView);
                    this.contentSystemEditLayout.dialogContainerRegion.reset();
                    this.contentSystemAssignSkillDialogView = null;
                    this.dialog.close();
                    this.dialog = null;
                    this.mainView.setIgnoreDomEvents(false);
                }
            },

            _restoreSelectedData: function() {
                LEContent.logger.debug("restore data", "ContentSystemTableController:_restoreSelectedData");
                if(this.selectedContentModel) {
                    var model = this.modelAll.createContextModel(this.selectedContentModel.attributes);
                    this.pageModel.setContentModel(model);
                    if(this.isDataChanged) {
                        this.pageModel._validateSaveAllowed();
                    }
                    this.selectedContentModel = null;
                    this.isDataChanged = false;
                    this._updateButtonsState(this.pageModel.getSelectedSkill());
                }
            },

            _cancelEdit: function () {
                if(this.pageModel.getIsSaveAllowed() || !_.isEmpty(this.newAssignSkills)) {
                    this._showNotification( null, this._closeWindowActionCallback, this._cancelCallback,
                                            {content: LE.translator.translate("LEContent.content.edit.route.confirmation.msg"), removePrimaryButton: true});
                } else {
                    this._clear();
                    this._routeToTable();
                }
            },

            //Notification area
            _showNotification: function (saveCallback, actionCallback, cancelCallback, options) {
                LEContent.logger.debug("show notification", "ContentSystemTableController:_showNotification. options = " + options);
                options = options || {};

                var removePrimaryButton = options.removePrimaryButton;
                if(_.isUndefined(removePrimaryButton)) {
                    removePrimaryButton = _.isEmpty(this.newAssignSkills) ? false : true;
                }
                var removeMiddleButton = options.removeMiddleButton || false;
                var title = options.title || LE.translator.translate("LEFramework.global.captions.are.you.sure");
                var content = options.content || LE.translator.translate("LEContent.content.gallery.system.unsave.changes.text");
                var text = options.text || LE.translator.translate("LEContent.content.edit.route.confirmation.save");
                var textMiddleButton = options.textMiddleButton || LE.translator.translate("LEContent.content.edit.route.confirmation.dont.save");

                this.confirmNotifier = LEContent.notifier.showConfirm({
                    title: title,
                    content: content,
                    removePrimaryButton: removePrimaryButton,
                    removeMiddleButton: removeMiddleButton,
                    objectAction: {
                        text: text,
                        callback: saveCallback ? _.bind(saveCallback, this, options) : null,
                        textMiddleButton: textMiddleButton,
                        middleCallback: actionCallback ? _.bind(actionCallback, this, options) : null,
                        cancelCallback: cancelCallback ? _.bind(cancelCallback, this, options) : null
                    }
                });
            },
            _unsavedChangesSaveCallback: function (options) {
                LEContent.logger.debug("save changed data before change skill", "ContentSystemTableController:_unsavedChangesSaveCallback. options = " + options);
                options = options || {};
                this.confirmNotifier.close();
                delete this.confirmNotifier;
                this._save({skillIdSelectedAfterSave: options.skillId});
            },
            _unsavedChangesActionCallback: function (options) {
                LEContent.logger.debug("don't save changed data before change skill", "ContentSystemTableController:_unsavedChangesActionCallback. options = " + options);
                options = options || {};
                this.confirmNotifier.close();
                delete this.confirmNotifier;
                this._assignSkillChanged(options.skillId);
            },
            _closeWindowActionCallback: function (options) {
                LEContent.logger.debug("cancel change skill", "ContentSystemTableController:_unsavedChangesActionCallback. options = " + options);
                options = options || {};
                this.confirmNotifier.close();
                delete this.confirmNotifier;
                this._clear();
                this._routeToTable();
            },
            _changePageSaveCallback: function (options) {
                LEContent.logger.debug("save changed data before change auto message", "ContentSystemTableController:_changePageSaveCallback. options = " + options);
                options = options || {};
                this.confirmNotifier.close();
                delete this.confirmNotifier;
                this.pageModel.setAllowMiniErrors(true);
                this._save({successCallback: this._routeToItem, autoMessageId: [options.idx]});
            },
            _changePageActionCallback: function (options) {
                LEContent.logger.debug("don't save changed data before change auto message", "ContentSystemTableController:_changePageActionCallback. options = " + options);
                options = options || {};
                this.confirmNotifier.close();
                delete this.confirmNotifier;
                this.pageModel.setAllowMiniErrors(true);
                this._routeToItem(options.idx);
            },
            _changePageCancelCallback: function (options) {
                LEContent.logger.debug("cancel change auto message", "ContentSystemTableController:_changePageCancelCallback. options = " + options);
                this._cancelCallback();
                this.pageModel.setAllowMiniErrors(true);
                this.pageModel.revertContentPageNumberChange();   //revert the page number change
            },
            _deleteCallback: function (options) {
                LEContent.logger.debug("delete skill", "ContentSystemTableController:_deleteCallback. options = " + options);
                this._cancelCallback();
                this._deleteSkill(options.modelToDelete, options.selectedSkill);
            },
            _cancelCallback: function () {
                LEContent.logger.debug("cancel action", "ContentSystemTableController:_cancelCallback");
                this.confirmNotifier.close();
                delete this.confirmNotifier;
            },

            //loader
            _showLoader: function(){
                this.mainView.showLoader();
            },
            _closeLoader: function(){
                this.mainView.closeLoader();
            }
        });
    });
    return  ContentSystemEditController;
});
